import { Link } from "react-router-dom";
import { LifeBuoy, Wind } from "lucide-react";

// Always-visible one-tap calm button (inside the app shell)
export const CalmButton = () => (
  <Link to="/sos" className="fixed right-3 bottom-24 lg:right-auto lg:left-[17rem] lg:bottom-6 z-30 rounded-full bg-[#2A2550] text-white shadow-lg w-12 h-12 lg:w-auto lg:h-auto lg:px-4 lg:py-3 flex items-center justify-center gap-2 hover:-translate-y-0.5 transition-transform" aria-label="SOS Calm: breathe and ground yourself now" title="SOS Calm" data-testid="calm-fab">
    <Wind size={18} /><span className="hidden lg:inline text-sm font-semibold">Calm</span>
  </Link>
);

export const SosHomeCard = () => (
  <div className="mb-6">
  <Link to="/sos" className="rounded-3xl bg-[#2A2550] text-white p-5 flex items-center gap-4 hover:-translate-y-0.5 transition-transform" data-testid="home-sos-card">
    <div className="w-12 h-12 rounded-2xl bg-white/10 flex items-center justify-center shrink-0"><Wind size={22} /></div>
    <div className="flex-1">
      <div className="font-semibold">Feeling overwhelmed right now?</div>
      <div className="text-sm text-white/70">SOS Calm: one minute of breathing, then grounding. Works offline.</div>
    </div>
    <span className="rounded-full bg-white text-[#2A2550] text-sm font-semibold px-4 py-2 shrink-0">Start</span>
  </Link>
  <Link to="/safety-plan-now" className="mt-2 ml-2 inline-flex items-center gap-1.5 text-sm font-semibold text-mm-primary hover:underline" data-testid="home-safety-plan-link"><LifeBuoy size={15} />Use my safety plan step by step</Link>
  </div>
);
